import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../../utils/Style/component/skeleton.scss';

const TransactionDetailsSkeleton = () => {
    const divs = Array.from({ length: 3 }, (_, index) => (
        <div className="my-2" key={index}>
            <Skeleton className="transaction-details-divs" />
        </div>
    ));

    return (
        <div className="my-4" style={{width: "25%",
            position: "absolute",
            top: "30%",
            left: "74%"}}>
            <div className="row my-1">
                <div className="col-5"></div>
                <div className="col-2">
                    <Skeleton className="transaction-details" />
                </div>
                <div className="col-5"></div>
            </div>
            <div className="row my-1">
                <div className="col-3"></div>
                <div className="col-6">
                    <Skeleton className="transaction-details" />
                </div>
                <div className="col-3"></div>
            </div>
            <div className="row my-1">
                <div className="col-4"></div>
                <div className="col-4">
                    <Skeleton width={'100%'} height={30} />
                </div>
                <div className="col-4"></div>
            </div>
            <div className="mt-4">
                {divs}
            </div>
        </div>
    );
}

export default TransactionDetailsSkeleton;